import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';

export * from './deleteFileUpload';

export function fileUploadError(error) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: error.code,
    message: error.message
  };
}
